import React from 'react';
import { Pagination } from 'antd';
import PropTypes from 'prop-types';
import { MySelect } from '../..';
import './styles.scss';
import { FormattedMessage } from 'react-intl';

const ITEM_PER_PAGE = 10;
const OPTION_ITEM_PER_PAGE = [
  { name: '5', id: 5 },
  { name: '10', id: 10 },
  { name: '20', id: 20 },
  { name: '30', id: 30 },
  { name: '40', id: 40 },
  { name: '50', id: 50 },
];
const MyPagination = ({
  size,
  totalItem,
  pageSize,
  onChange,
  currentPage,
  options,
}) => {
  if (!totalItem || totalItem <= 0) return null;

  return (
    <div className="wrapper-paginate d-table w-100p">
      <div className="d-table-cell va-m">
        <span className="display-text">
          <FormattedMessage id="pagination.show" />
        </span>
        <div className="d-inline-block">
          <MySelect
            className="select-display"
            value={pageSize}
            options={options}
            placeholder=""
            onChange={(pageSize) => {
              const payload = {
                skip: 0,
                current: 1,
                take: pageSize,
              };
              onChange(payload);
            }}
            allowClear={false}
          />
        </div>

        <span className="display-text pl-20">
          <FormattedMessage id="pagination.of_records" values={{ total: totalItem }} />
        </span>
      </div>

      <Pagination
        current={currentPage}
        size={size}
        total={totalItem}
        pageSize={pageSize}
        className="my-table-pagination py-16"
        showSizeChanger={false}
        onChange={(page) => {
          const payload = {
            skip: (page - 1) * pageSize,
            current: page,
            take: pageSize,
          };
          onChange(payload);
        }}
      />
    </div>
  );
};

MyPagination.propTypes = {
  size: PropTypes.string,
  totalItem: PropTypes.number,
  pageSize: PropTypes.number,
  onChange: PropTypes.func,
  currentPage: PropTypes.number,
  options: PropTypes.array,
};

MyPagination.defaultProps = {
  size: 'small',
  totalItem: 0,
  currentPage: 1,
  pageSize: ITEM_PER_PAGE,
  onChange: () => null,
  options: OPTION_ITEM_PER_PAGE,
};

export default MyPagination;
